import { render, staticRenderFns } from "./FavDetail.vue?vue&type=template&id=07589af5&scoped=true"
import script from "./FavDetail.vue?vue&type=script&lang=js"
export * from "./FavDetail.vue?vue&type=script&lang=js"
import style0 from "./FavDetail.vue?vue&type=style&index=0&id=07589af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07589af5",
  null
  
)

export default component.exports